var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "box" }, [
    _c("img", {
      staticClass: "topBg",
      attrs: { src: require("assets/spTitle.png"), alt: "" }
    }),
    _vm._v(" "),
    _c("div", { staticClass: "cjjjBox", on: { click: _vm.showTc } }, [
      _c("img", {
        staticClass: "topBg minWidth",
        attrs: { src: require("assets/cjjj.png"), alt: "" }
      }),
      _vm._v(" "),
      _vm.showTcStatus
        ? _c("div", { staticClass: "tanchuang" }, [_vm._m(0)])
        : _vm._e(),
      _vm._v(" "),
      _c("div", {
        staticClass: "zhezhao",
        on: {
          click: function($event) {
            $event.stopPropagation()
            _vm.show1216($event)
          }
        }
      }),
      _vm._v(" "),
      _vm.show1216pic
        ? _c("img", {
            staticClass: "zhezhaoPic",
            attrs: { src: require("assets/1216mask1.png"), alt: "" }
          })
        : _vm._e()
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "w14" }, [
      _c("div", { staticClass: "relativeBox" }, [
        _c("img", {
          staticClass: "minWidth",
          attrs: { src: require("assets/cxzbT.png"), alt: "" }
        }),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "spjs",
            on: {
              click: function($event) {
                _vm.to("video")
              }
            }
          },
          [_vm._v("视频介绍")]
        ),
        _vm._v(" "),
        _c(
          "a",
          { staticClass: "lj", attrs: { href: "https://www.itnbear.com/" } },
          [_vm._v("业务系统")]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "betweenBox" }, [
        _c(
          "div",
          { staticClass: "betweenItemBox", on: { click: _vm.show1216mask2 } },
          [
            _c("img", { attrs: { src: require("assets/be1.png"), alt: "" } }),
            _vm._v(" "),
            _c("div", { attrs: { id: "myChart" } }),
            _vm._v(" "),
            _vm.show1216mask22
              ? _c("img", {
                  staticClass: "mask12162",
                  attrs: { src: require("assets/1216mask2.png"), alt: "" }
                })
              : _vm._e()
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "betweenItemBox", on: { click: _vm.show1216mask3 } },
          [
            _c("img", { attrs: { src: require("assets/be2.png"), alt: "" } }),
            _vm._v(" "),
            _c("div", { attrs: { id: "myChart1" } }),
            _vm._v(" "),
            _vm.show1216mask33
              ? _c("img", {
                  staticClass: "mask12162",
                  attrs: { src: require("assets/1216mask3.png"), alt: "" }
                })
              : _vm._e()
          ]
        )
      ]),
      _vm._v(" "),
      _vm._m(1)
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "w14" }, [
      _c("img", {
        staticClass: "minWidth",
        attrs: { src: require("assets/lczzT.png"), alt: "" }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "gcContentBox" }, [
        _c(
          "div",
          { staticClass: "gcCTabListBox" },
          _vm._l(_vm.gzTabList, function(item, index) {
            return _c(
              "div",
              {
                staticClass: "gcCTabList",
                class: { active: _vm.gzStatus == index },
                on: {
                  click: function($event) {
                    _vm.changegzStatus(index)
                  }
                }
              },
              [_vm._v("\n          " + _vm._s(item) + "\n        ")]
            )
          })
        ),
        _vm._v(" "),
        _c("div", { staticClass: "gcCBox" }, [
          _vm.gzStatus == 0
            ? _c("img", {
                staticClass: "minWidth",
                attrs: { src: require("assets/ywlc.png"), alt: "" }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.gzStatus == 1
            ? _c("img", {
                staticClass: "minWidth",
                attrs: { src: require("assets/sjjc.png"), alt: "" }
              })
            : _vm._e()
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "w14" }, [
      _c("img", {
        staticClass: "minWidth",
        attrs: { src: require("assets/hxcjT.png"), alt: "" }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "gcContentBox" }, [
        _c(
          "div",
          { staticClass: "gcCTabListBox" },
          _vm._l(_vm.gcCTabList, function(item, index) {
            return _c(
              "div",
              {
                staticClass: "gcCTabList",
                class: { active: _vm.gcCStatus == index },
                on: {
                  click: function($event) {
                    _vm.changegcCStatus(index)
                  }
                }
              },
              [_vm._v("\n          " + _vm._s(item) + "\n        ")]
            )
          })
        ),
        _vm._v(" "),
        _c("div", { staticClass: "gcCBox" }, [
          _vm.gcCStatus == 0
            ? _c("img", {
                staticClass: "minWidth",
                attrs: { src: require("assets/xlcp.png"), alt: "" }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.gcCStatus == 1
            ? _c("img", {
                staticClass: "minWidth",
                attrs: { src: require("assets/lflk.png"), alt: "" }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.gcCStatus == 2
            ? _c("img", {
                staticClass: "minWidth",
                attrs: { src: require("assets/shbf.png"), alt: "" }
              })
            : _vm._e()
        ])
      ])
    ]),
    _vm._v(" "),
    _vm._m(2),
    _vm._v(" "),
    _vm._m(3),
    _vm._v(" "),
    _c("div", { staticClass: "topBox" }, [
      _c("div", { staticClass: "ggtpBox2" }, [
        _c("img", { attrs: { src: require("assets/qdcxT.png"), alt: "" } }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "ttTabBox" },
          _vm._l(_vm.cxList, function(item, index) {
            return _c(
              "div",
              {
                staticClass: "ttTab",
                class: { active: _vm.cxStatus == index },
                on: {
                  click: function($event) {
                    _vm.changeCxStatus(index)
                  }
                }
              },
              [_vm._v("\n          " + _vm._s(item) + "\n        ")]
            )
          })
        ),
        _vm._v(" "),
        _c("div", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: false,
              expression: "false"
            }
          ],
          staticClass: "auto sp90",
          attrs: { id: "myChart4" }
        }),
        _vm._v(" "),
        _vm.cxStatus == 1
          ? _c("img", {
              staticClass: "auto sp90",
              attrs: { src: require("assets/zffx.png"), alt: "" }
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.cxStatus == 0
          ? _c("img", {
              staticClass: "auto sp90",
              attrs: { src: require("assets/fxcd.png"), alt: "" }
            })
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "ggtpBox2" }, [
        _c(
          "div",
          { staticClass: "zcTabBox" },
          [
            _c("img", { attrs: { src: require("assets/line.png"), alt: "" } }),
            _vm._v(" "),
            _vm._l(_vm.zcList, function(item, index) {
              return _c(
                "div",
                {
                  staticClass: "zcTabItem",
                  class: { active: _vm.zcTabStatus == index },
                  on: {
                    click: function($event) {
                      _vm.changeZcTabStatus(index)
                    }
                  }
                },
                [_vm._v("\n          " + _vm._s(item) + "\n        ")]
              )
            })
          ],
          2
        ),
        _vm._v(" "),
        _vm.zcTabStatus == 0
          ? _c(
              "div",
              [
                _c("img", {
                  staticClass: "minWidth",
                  staticStyle: { "margin-bottom": "0.3rem" },
                  attrs: { src: require("assets/zcCT.png"), alt: "" }
                }),
                _vm._v(" "),
                _vm._l(3, function(item, index) {
                  return _c("img", {
                    staticClass: "sp90",
                    staticStyle: { margin: "0 auto 0.28rem" },
                    attrs: {
                      src: _vm.EnvUrl + "zcwj" + (index + 1) + ".png",
                      alt: ""
                    },
                    on: {
                      click: function($event) {
                        _vm.changezcStatus(index + 1)
                      }
                    }
                  })
                })
              ],
              2
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.zcTabStatus == 1
          ? _c(
              "div",
              [
                _c("img", {
                  staticClass: "minWidth",
                  staticStyle: { margin: "0.3rem auto" },
                  attrs: { src: require("assets/tpqdT.png"), alt: "" }
                }),
                _vm._v(" "),
                _vm._l(4, function(item, index) {
                  return _c("img", {
                    staticClass: "sp90",
                    staticStyle: { margin: "0 auto 0.28rem" },
                    attrs: {
                      src: _vm.EnvUrl + "qd0" + (index + 1) + ".png",
                      alt: ""
                    },
                    on: {
                      click: function($event) {
                        _vm.changeGgtpStatus(index + 1)
                      }
                    }
                  })
                })
              ],
              2
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.zcTabStatus == 2
          ? _c(
              "div",
              { staticStyle: { "padding-top": "0.3rem" } },
              _vm._l(6, function(item, index) {
                return _c("img", {
                  staticStyle: { margin: "0 auto 0.24rem" },
                  attrs: { src: _vm.EnvUrl + "ddt" + index + ".png", alt: "" },
                  on: {
                    click: function($event) {
                      _vm.changeGzdtStatus(index)
                    }
                  }
                })
              })
            )
          : _vm._e()
      ])
    ]),
    _vm._v(" "),
    _vm.mask
      ? _c(
          "div",
          {
            staticClass: "maskBox",
            on: {
              click: function($event) {
                _vm.closeMask()
              }
            }
          },
          [
            _c(
              "div",
              {
                staticClass: "mask",
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                  }
                }
              },
              [
                _vm.zcStatus > 0
                  ? _c("div", { staticClass: "wm14" }, [
                      _c("div", { staticClass: "zcTop" }, [
                        _c("img", {
                          attrs: { src: require("assets/zcwj.png"), alt: "" }
                        }),
                        _vm._v(" "),
                        _vm.zcStatus != 0
                          ? _c(
                              "div",
                              {
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    _vm.changezcStatus(0)
                                  }
                                }
                              },
                              [_vm._v("\n            返回 >\n          ")]
                            )
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _vm.zcStatus == 1
                        ? _c("div", { staticClass: "zcList" }, [
                            _c("img", {
                              staticClass: "zcImg minWidth",
                              attrs: { src: _vm.EnvUrl + "zcd2.png", alt: "" }
                            })
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.zcStatus == 2
                        ? _c("div", { staticClass: "zcList" }, [
                            _c("img", {
                              staticClass: "zcImg minWidth",
                              attrs: { src: _vm.EnvUrl + "zcd3.png", alt: "" }
                            })
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.zcStatus == 3
                        ? _c("div", { staticClass: "zcList" }, [
                            _c("img", {
                              staticClass: "zcImg minWidth",
                              attrs: { src: _vm.EnvUrl + "zcd4.png", alt: "" }
                            })
                          ])
                        : _vm._e()
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.ggtpStatus > 0
                  ? _c("div", { staticClass: "wm14" }, [
                      _c("div", { staticClass: "zcTop" }, [
                        _c("img", {
                          attrs: { src: require("assets/ggtpT.png"), alt: "" }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            on: {
                              click: function($event) {
                                _vm.changeGgtpStatus(0)
                              }
                            }
                          },
                          [_vm._v("返回 >")]
                        )
                      ]),
                      _vm._v(" "),
                      _vm.ggtpStatus >= 0
                        ? _c("div", { staticClass: "zcList" }, [
                            _c("img", {
                              staticClass: "minWidth",
                              attrs: {
                                src:
                                  _vm.EnvUrl + "qdx0" + _vm.ggtpStatus + ".png",
                                alt: ""
                              }
                            })
                          ])
                        : _vm._e()
                    ])
                  : _vm._e()
              ]
            )
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.gzdtStatus >= 0
      ? _c("div", { staticClass: "wm14" }, [
          _c("div", { staticClass: "zcTop" }, [
            _c("img", { attrs: { src: require("assets/gzdtT.png"), alt: "" } }),
            _vm._v(" "),
            _vm.gzdtStatus >= 0
              ? _c(
                  "div",
                  {
                    on: {
                      click: function($event) {
                        _vm.changeGzdtStatus(-1)
                      }
                    }
                  },
                  [_vm._v("返回 >")]
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _vm.gzdtStatus >= 0
            ? _c("div", { staticClass: "zcList" }, [
                _c("img", {
                  attrs: {
                    src: _vm.EnvUrl + "dtx" + _vm.gzdtStatus + ".png",
                    alt: ""
                  }
                })
              ])
            : _vm._e()
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "paddingBox" }, [
      _c("div", [_vm._v("正常：64人")]),
      _vm._v(" "),
      _c("div", [_vm._v("轻度：252人")]),
      _vm._v(" "),
      _c("div", [_vm._v("中度：48人")]),
      _vm._v(" "),
      _c("div", [_vm._v("重度：9人")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "betweenBox" }, [
      _c("div", { staticClass: "betweenItemBox" }, [
        _c("img", { attrs: { src: require("assets/be3.png"), alt: "" } }),
        _vm._v(" "),
        _c("div", { attrs: { id: "myChart2" } })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "betweenItemBox" }, [
        _c("img", { attrs: { src: require("assets/be4.png"), alt: "" } }),
        _vm._v(" "),
        _c("div", { attrs: { id: "myChart3" } })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "w14" }, [
      _c("img", {
        staticClass: "minWidth",
        attrs: { src: require("assets/sjgx.png"), alt: "" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "topBox" }, [
      _c("div", { staticClass: "ggtpBox" }, [
        _c("img", {
          staticClass: "minWidth",
          attrs: { src: require("assets/gzzb.png"), alt: "" }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "ggtpBox" }, [
        _c("img", {
          staticClass: "minWidth",
          attrs: { src: require("assets/gzjh.png"), alt: "" }
        })
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7b54854c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b54854c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/information.vue
// module id = null
// module chunks = 